<template>
	<div class="b-container">
		<div class="mask-img-container">
			<img src="https://image.comein.cn/web/irm/web/calendar/fade_1.png" alt="" class="mask-img" />
			<div class="mask-img-mix"></div>
		</div>
		<div class="result-tips">
			<m-svg-icon name="result_success" class="result-svg" />
			<span>{{ $t('enterprise.leave-word.submitted-tip') }}</span>
		</div>
		<div class="result-content">
			<div v-html="getSubmitContent" class="result-main-body"></div>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';

const moduleOptions = ref({});
const getSubmitContent = computed(() => {
	const { submitDescList } = moduleOptions.value;
	if (submitDescList && submitDescList.length) {
		return submitDescList[0].desc;
	}
	return '';
});

const { leave_word_config } = useModuleData();

onMounted(async () => {
	await leave_word_config.refresh();
	const options = leave_word_config.data?.data || {};
	moduleOptions.value = options;
});
</script>

<style lang="less" scoped>
.b-container {
	background: linear-gradient(180deg, var(--ir-theme-color-opacity-1) 0%, #f6f7f8 100%);
	position: relative;
	overflow: hidden;

	.mask-img-container {
		position: absolute;
		top: 0;
		right: 0;
		width: 2.18rem;
		height: 0.93rem;
		pointer-events: none;

		.mask-img {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
		}
		.mask-img-mix {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background: var(--ir-theme-color);
			z-index: 3;
			mix-blend-mode: hue;
		}
	}

	.result-tips {
		margin: 0.64rem auto 0;
		display: flex;
		justify-content: center;
		align-items: center;

		.result-svg {
			font-size: 0.24rem;
			color: var(--ir-theme-color);
		}
		span {
			margin-left: 0.08rem;
			color: #333;
			/* 20/H2-medium */
			font-family: 'PingFang SC';
			font-size: 0.2rem;
			font-style: normal;
			font-weight: 500;
			line-height: 140%; /* 28px */
		}
	}
	.result-content {
		margin: 0 auto;
		margin-top: 0.64rem;
		padding: 0 0.38rem 0.08rem 0.38rem;
		width: 2.9rem;
		height: 3.5rem;
		background: url('~@/assets/images/irstore/appointment_mask.png') no-repeat;
		background-size: cover;
		background-position: 100% 100%;
		display: flex;
		align-items: center;
		.result-main-body {
			color: #1d2129;
			/* 15/H5-regular */
			font-family: 'PingFang SC';
			font-size: 0.15rem;
			font-style: normal;
			font-weight: 400;
			line-height: 140%; /* 21px */
			white-space: pre-wrap;
			min-height: 0.24rem;
		}
	}
}
</style>
